import type { UserProfile } from '../types/user'

export const useTeamMembers = () => useState<UserProfile[]>('team-members', () => [] as UserProfile[])
